import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters/getters'
import { mutations } from './mutations'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  batchMatchTrans: {
    init: 0,
    initErr: [],
    menu: {}
  },
  performMatch: {
    init: 0,
    initErr: [],
    menu: {}
  },
  matchListing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  matchData: {
    actionName: '',
    branch: '',
    accountNo: '',
    type: '',
    documentNo: '',
    fund: '',
    suffix: '',
    tranMode: '',
    action: '',
    acctYr: '',
    acctMth: '',
    curr: '',
    frmModule: '',
    printDoc: '',
    mdJrnl: '',
    mdAcctNo: '',
    mdBranch: '',
    mdType: '',
    mdDocNo: '',
    mdFund: '',
    mdSuffix: '',
    matchedOn: '',
    matched: '',
    mdProgId: ''
  },
  matchSelectedList: {
    selectedMatchListing: []
  },
  matchDataEdit: {
    matchOn: '',
    matchedRecTransDate: ''
  },
  recLock: {
    isUnlock: true
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
